import { render, staticRenderFns } from "./afasCountrySelect.vue?vue&type=template&id=fb48e0d8&"
import script from "./afasCountrySelect.vue?vue&type=script&lang=js&"
export * from "./afasCountrySelect.vue?vue&type=script&lang=js&"
import style0 from "./afasCountrySelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports